import {
  DropdownMenuGroup,
  DropdownMenuLabel,
} from '@radix-ui/react-dropdown-menu';
import { ChevronDown } from '@remarkable/ark-icons';

import { Button } from 'src/components';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
} from 'src/components/DropdownMenu';

interface UserPropertiesDropdownProps {
  label: string;
  selected: (string | undefined)[] | null;
  dropdownOptions: { value: string | undefined; label: string }[];
  onCheckedChange: (item: string | undefined, checked: boolean) => void;
  className: string;
  disabled?: boolean;
}
export const UserPropertiesDropdown = (opts: UserPropertiesDropdownProps) => {
  const selectedDisplayValue = opts.selected?.length
    ? opts.selected
        .map(
          (item) =>
            opts.dropdownOptions.find((opt) => opt.value === item)?.label ||
            item
        )
        .join(', ')
    : 'None';
  return (
    <DropdownMenuGroup className={opts.className}>
      <DropdownMenuLabel className="font-medium">
        {opts.label}
      </DropdownMenuLabel>
      <DropdownMenu
        trigger={
          <Button
            variant="secondary"
            size="large"
            disabled={opts.disabled}
            className="w-full justify-between"
          >
            <span>{selectedDisplayValue}</span>
            <ChevronDown />
          </Button>
        }
      >
        {opts.dropdownOptions.map((item) => (
          <DropdownMenuCheckboxItem
            key={item.value}
            checked={opts.selected?.includes(item.value)}
            onCheckedChange={(checked) =>
              opts.onCheckedChange(item.value, checked)
            }
          >
            {item.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenu>
    </DropdownMenuGroup>
  );
};
